import {Http} from './index.js'
import Resource from './resource-class'

class CultureAPI extends Resource {
  constructor () {
    super()
    this.resource = '/culture'
  }

  create (items = []) {
    /*
      Submits a list of cultures to the API.
    */
    const cultures = []
    items.forEach((e) => {
      const culture = {
        experiment_class_id: e.experiment_class ? e.experiment_class.experiment_class_id : undefined,
        medium_id: e.culture_medium ? e.culture_medium.culture_medium_id : undefined,
        study_id: e.culture_study ? e.culture_study.culture_study_id : undefined,
        fermentation_temperature: e.fermentation_temperature ? parseFloat(e.fermentation_temperature) : undefined,
        fermentation_volume: e.fermentation_volume ? parseFloat(e.fermentation_volume) : undefined,
        organization_id: e.organization.organization_id,
        researcher_id: e.researcher.user_details_id,
        fermentation_time: e.fermentation_time,
        inoculation_date: e.inoculation_date
      }
      const taxonomy = {taxonomy_id: e.taxonomy.taxonomy_id}
      const payload = {
        culture,
        taxonomy
      }
      cultures.push(payload)
    })
    return Http.post(this.resource, cultures)
  }

  getGroupedCultures ({filterParams = {}} = {}) {
    const url = `${this.resource}/grouped`
    return Http.get(url)
  }
}

export default new CultureAPI()
